import PropTypes from 'prop-types'
import React, {useEffect, useRef, useState} from 'react'
import {FiX} from 'react-icons/fi'
import {useAppSelector} from "../../redux/store";
import {useTranslation} from "react-i18next";
import {ButtonPrimary} from "../button";
import {GiPayMoney} from "react-icons/gi";
import {ModalTopUp} from "../modals";
import {UserAction} from "../../redux/reducers/user";
import {useDispatch} from "react-redux";
import {useUserInfo} from "../../service/api.swr";
import {AlertBig, AlertBigInfoText} from "./AlertBig";
import {EAlert} from "../../enums";

export const Alert = ({
								 outlined = false,
								 raised = false,
								 rounded = false,
								 borderLeft = false,
								 canHide = true,
								 icon = null,
								 size = 'default',
								 color,
								 children
							 }) => {
	const [hidden, setHidden] = useState(false)
	let css = []
	css.push(color)
	if (outlined) css.push(`border border-current`)
	if (raised) css.push('shadow')
	if (rounded) css.push('rounded-lg')
	if (hidden) css.push('hidden')
	if (borderLeft) css.push('border-l-4 border-current')
	if (size === 'sm') {
		css.push('p-2')
	} else {
		css.push('p-4')
	}
	css = css.join(' ')
	return (
		<div className={`w-full flex items-center justify-start p-4 ${css}`}>
			<div className="flex-shrink">{icon}</div>
			<div className="flex-grow">{children}</div>
			<div className="flex-shrink">
				{!canHide ?
					<button
						className="ml-auto flex items-center justify-center"
						onClick={() => setHidden(!hidden)}>
						<FiX className="stroke-current h-4 w-4"/>
					</button> : null}
			</div>
		</div>
	)
}

Alert.propTypes = {
	color: PropTypes.string,
	outlined: PropTypes.bool,
	raised: PropTypes.bool,
	rounded: PropTypes.bool,
	icon: PropTypes.any,
	children: PropTypes.any
}

export const AlertInstruction = ({
																	 className,
																	 children,
																	 ...rest
																 }) => {

	return (
		<Alert
			color={`bg-transparent border-blue-500 text-normal text-gray-500 ${className}`}
			borderLeft
			size={"sm"}
			raised
			{...rest}
		>
			{children}
		</Alert>
	)
}


export const AlertLowBalance = ({refreshInterval = 5 * 60 * 1000, throttleInterval = 60 * 1000}) => {
	const {t} = useTranslation()
	const [isTopUpModalVisible, setTopUpModalVisible] = useState(false)

	const {data: user, isLoading} = useUserInfo()
	if(isLoading || !user || user.balance >= 5) return null;

	return (
		<>
			<AlertBig
				type={EAlert.error}
				title={t(`alert.lowbalance.title`)}
			>
				<AlertBigInfoText>{t(`alert.lowbalance.current_balance`, {balance: parseFloat(user.balance)})}</AlertBigInfoText>
				<AlertBigInfoText>{t(`alert.lowbalance.description`)}</AlertBigInfoText>

				<div style={{marginTop: '16px'}}>
					<ButtonPrimary
						type="button"
						onClick={()=> setTopUpModalVisible(true)}
						data-red
					>
						{t(`alert.lowbalance.btn_topup`)}
					</ButtonPrimary>
				</div>

				<ModalTopUp
					isOpen={isTopUpModalVisible}
					onCancel={()=> setTopUpModalVisible(false)}
				/>
			</AlertBig>
		</>
	)
};
